import { useQuery } from '@apollo/client';

import { QueryHookOptions } from '../..';
import { PARTNER_CONFIGS } from '../partnerConfigsTypeDefs';

export const useQueryPartnerConfigs = (options?: QueryHookOptions<typeof PARTNER_CONFIGS>) =>  (
  useQuery(PARTNER_CONFIGS, { ...options, fetchPolicy: 'cache-first' })
);
